import { Container, Graphics } from "pixi.js"
import { applyVelocity } from "./lib/apply-velocity"
import { applyFriction } from "./lib/apply-friction"

export async function Particles({ isSolid }) {
  const particles = new Container()

  const spawnParticle = ({
    x,
    y,
    velocity = { x: 0, y: 0 },
    duration = 1000,
    color = "#fff6",
  }) => {
    const particle = new Graphics()
    particle.x = x
    particle.y = y
    particle.velocity = velocity
    particle.duration = duration
    particle.birth = Date.now()

    particle.rect(-0.5, -0.5, 1, 1).fill(color)
    particles.addChild(particle)
  }

  const tick = (time) => {
    const now = Date.now()

    particles.children.forEach((particle) => {
      if (now - particle.birth > particle.duration) {
        particles.removeChild(particle)
        return
      }

      applyVelocity(particle, { time, isSolid })
      applyFriction(particle, { time, friction: 0.02 })
    })
  }

  return { particles, spawnParticle, tick }
}
